export default "__VITE_ASSET__oPljt5oD__"